import React from 'react';
import { Heart } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const WishlistButton = ({ artworkId, variant = 'default', className = '' }) => {
  const { user, login, refreshUser } = useAuth();
  const isWishlisted = user?.wishlist?.includes(artworkId);

  const toggleWishlist = async (e) => {
    e.stopPropagation();
    if (!user) {
      login();
      return;
    }
    try {
      if (isWishlisted) {
        await axios.delete(`${API}/wishlist/${artworkId}`, { withCredentials: true });
        toast.success('Removed from wishlist');
      } else {
        const res = await axios.post(`${API}/wishlist/${artworkId}`, {}, { withCredentials: true });
        toast.success(res.data.message || 'Added to wishlist');
      }
      await refreshUser();
    } catch {
      toast.error('Failed to update wishlist');
    }
  };

  if (variant === 'compact') {
    return (
      <button
        onClick={toggleWishlist}
        data-testid={`wishlist-btn-compact-${artworkId}`}
        className={`p-1.5 rounded-full transition-all hover:scale-110 active:scale-95 ${
          isWishlisted
            ? 'bg-red-500 text-white'
            : 'bg-white/15 backdrop-blur-sm text-white hover:bg-white/40'
        } ${className}`}
        title={isWishlisted ? 'Remove from wishlist' : 'Add to wishlist'}
      >
        <Heart size={14} fill={isWishlisted ? 'currentColor' : 'none'} />
      </button>
    );
  }

  return (
    <button
      onClick={toggleWishlist}
      data-testid={`wishlist-btn-${artworkId}`}
      className={`p-2.5 rounded-full border transition-all hover:scale-110 active:scale-95 ${
        isWishlisted
          ? 'bg-red-50 border-red-300 text-red-500'
          : 'border-border bg-card text-muted-foreground hover:text-red-500 hover:border-red-300'
      } ${className}`}
      title={isWishlisted ? 'Remove from wishlist' : 'Add to wishlist'}
    >
      <Heart size={18} fill={isWishlisted ? 'currentColor' : 'none'} />
    </button>
  );
};

export default WishlistButton;
